import * as React from 'react'

import { Site } from '../../../../common/constants/siteList'
import { ILocationParams } from '../../../../common/reducers/reactRouterLocation'
import { IDecoratedItem } from '../../../../typings/searchResults'
import DefaultItemCard from './defaultItemCard'
import PhotoduneGridItemCard from './photoduneGridItemCard/photoduneItemCardContainer'

interface IProps extends IDecoratedItem {
  currentSite: Site
  viewType: string
  locationParams: ILocationParams
}

const ItemCard = ({ currentSite, ...props }: IProps): any => {
  if (currentSite === Site.photodune) {
    return <PhotoduneGridItemCard {...props} />
  }

  return <DefaultItemCard {...props} />
}

export default ItemCard
